import { Link } from 'react-router-dom';

export default function FeaturedCabinSpotlight() {
  return (
    <section className="w-full bg-[#F5F1EB] py-0 overflow-hidden">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row min-h-[580px]">

        {/* Image Side */}
        <div className="relative w-full lg:w-[58%] min-h-[420px] lg:min-h-[580px] overflow-hidden">
          <img
            src="https://static.readdy.ai/image/ad5520ee7149a263b01f4e3410f2d685/6621c51b505ccdecc14eea48184d7049.jpeg"
            alt="Glen Falls Luxury Cabin exterior — Highlands, NC"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          {/* subtle gradient overlay on right edge for blending */}
          <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-r from-transparent to-[#F5F1EB] hidden lg:block" />

          {/* Floating badge */}
          <div className="absolute top-8 left-8 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full flex items-center gap-2 shadow-sm">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-star-fill text-[#C9A96E] text-sm" />
            </div>
            <span className="text-[#1A1A18] text-xs font-jost font-medium tracking-wide">Airbnb Guest Favorite &bull; 5.0 Stars</span>
          </div>
        </div>

        {/* Content Side */}
        <div className="w-full lg:w-[42%] flex flex-col justify-center px-10 lg:pl-14 lg:pr-16 py-16">
          <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost font-light mb-6">
            / Featured Luxury Cabin
          </p>

          <h2 className="font-cormorant text-4xl lg:text-5xl text-[#1A1A18] font-light leading-none tracking-tight mb-6">
            Featured Luxury<br />
            <em className="italic">Cabin in Highlands, NC</em>
          </h2>

          {/* Accent line */}
          <div className="w-12 h-px bg-[#C9A96E] mb-7" />

          <h3 className="font-cormorant text-2xl text-[#2D4A3E] font-medium mb-4">
            Glen Falls Luxury Cabin
          </h3>

          <p className="text-[#5C5850] font-jost text-sm leading-relaxed mb-3">
            Glen Falls Luxury Cabin is one of the most sought-after luxury cabins in Highlands, NC, offering a rare combination of privacy, comfort, and proximity to one of the area&apos;s most beautiful waterfalls.
          </p>
          <p className="text-[#5C5850] font-jost text-sm leading-relaxed mb-8">
            Glen Falls Luxury Cabin in Highlands, NC consistently earns top guest reviews for its peaceful mountain setting, upscale design, and easy access to Glen Falls — making it an ideal choice for a refined getaway.
          </p>

          {/* Tags */}
          <div className="flex flex-wrap gap-2 mb-10">
            {['Near Glen Falls', 'Top 5% of Homes', 'Highlands, NC'].map((tag) => (
              <span
                key={tag}
                className="text-[#6B8C7D] text-xs font-jost border border-[#6B8C7D]/30 px-3 py-1 rounded-full"
              >
                {tag}
              </span>
            ))}
          </div>

          <div className="flex items-center gap-4">
            <a
              href="https://highlandsluxurycabins.com/best-luxury-cabins"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-[#2D4A3E] text-white text-xs tracking-[0.2em] uppercase font-jost font-medium px-9 py-4 rounded-full hover:bg-[#1e3329] transition-colors cursor-pointer whitespace-nowrap"
            >
              View Glen Falls Cabin
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line" />
              </div>
            </a>
            <Link
              to="/best-luxury-cabins"
              className="text-[#2D4A3E] text-xs tracking-[0.15em] uppercase font-jost font-medium border border-[#2D4A3E]/30 px-6 py-4 rounded-full hover:border-[#2D4A3E] transition-colors cursor-pointer whitespace-nowrap"
            >
              All Cabins
            </Link>
          </div>
        </div>

      </div>
    </section>
  );
}
